<template>
<div class="btn btn-dropdown" ref="el" v-on:click.prevent="dropdownOpen=!dropdownOpen">
  <slot name="label" />
  <i class="fa-solid fa-caret-down"></i>
  <ul class="dropdown" v-show="dropdownOpen">
    <slot />
  </ul>
</div>
</template>

<script>
export default {
  data: ()=>({
    dropdownOpen: false,
  }),
  mounted() {
    this.clickListener=document.addEventListener("click", (e)=>{
      var element=e.target;
      while(element) {
        if (element==this.$refs.el)
          return;
        element=element.parentNode;
      }
      this.dropdownOpen=false;
    });
  },
  unmounted() {
    document.removeEventListener("click", this.clickListener);
  },
}
</script>
